import React, { useState, useEffect} from 'react';
import { getBeneficiaries, referralStore } from '../services/authService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { showSuccess, showError } from '../utils/alert';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const VhndCreate = () => {
  const [beneficiary, setBeneficiary] = useState(null); // Initially null
  const [beneficiaryList, setBeneficiaryList] = useState([]);
  const [showUserForm, setShowUserForm] = useState(false);

 const selectedVillageId = useSelector((state) => state.village.selectedVillageId);
  const navigate = useNavigate();

  // Form state initialization 
  const [formData, setFormData] = useState({
    transportNeeded: '',
    escortNeeded: '',
    slipGiven: '',
    followUpChecked: false,
    referredTo: '',
    referralDate: '',
    reasonForReferral: '',
    urgencyLevel: '',
    transportType: '',
    escortPerson: '',
    currentSymptoms: '',
    referralSlipGiven: '',
    previousHospitalVisit: '',
    followUpDate: '',
    followUpType: '',
    followUpNotes: '',
    symptoms: '',
    hospitalVisit: '',
    followUpScheduled: false,
  });


  useEffect(() => {
    async function fetchBeneficiaries() {
      try {

        const getBen = await getBeneficiaries();

        // Check if the API call was successful
        if (getBen.status === true) {


          const formattedList = getBen.data.map((b) => ({
            id: b.beneficiary_id,
            name: b.name,
            age: b.age,
            gender: b.gender,
            condition: b.category,
            village: b.village_name,
          }));

          setBeneficiaryList(formattedList);

          // Automatically set the first beneficiary as default
          if (formattedList.length > 0) {
            setBeneficiary(formattedList[0]);
          }
        } else {
          console.error('API error:', getBen.message);
        }
      } catch (err) {
        console.error('Fetch error:', err);

      }
    }

    fetchBeneficiaries();
  }, [selectedVillageId]); // Empty dependency array ensures this runs only once on mount

  

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle form submission
  const handleSave = async () => {
    // Basic validation
    if (!formData.referredTo || !formData.referralDate || !formData.reasonForReferral || !formData.urgencyLevel) {
      showError('Please fill in all required fields.');
      return;
    }

    const payload = {
      beneficiary_id: beneficiary?.id,   
      referral_datetime: formData.referralDate + 'T09:00:00Z',
      referred_to: formData.referredTo,
      reason: formData.reasonForReferral,
      urgency_level: formData.urgencyLevel,
      transport_arranged: formData.transportNeeded === 'yes',
      completed: false,
      outcome: '',
    };

    try {
      const response = await referralStore(payload);

      if (response.status === true) {
        showSuccess(response.message || 'Referral saved successfully!');
        navigate('/referrals');
      } else {
        showError(response.message || 'Failed to save referral.');
      }
    } catch (error) {
      showError(error.message || 'An error occurred while saving the referral.');
    }


   
    
  };

  return (
     <>
  

      <div className="page-header">
              <button className="back-button" onClick={() => navigate('/referrals')}>
                <FontAwesomeIcon icon={faArrowLeft} />
                Back
              </button>
              <div className="page-title">New Referral</div>
            </div>
          

      {/* Beneficiary Section */}
      {beneficiary && (
        <div className="form-section">
          <div className="section-title">Select Beneficiary</div>
          <div className="beneficiary-card">
            <div className="beneficiary-info">
              <div className="beneficiary-name">{beneficiary.name}</div>
              <div className="beneficiary-details">
                {beneficiary.age} years • {beneficiary.gender} • {beneficiary.condition}
              </div>
              <div className="beneficiary-village">{beneficiary.village}</div>
            </div>
            <button className="change-button" onClick={() => setShowUserForm(!showUserForm)}>
              Change
            </button>
          </div>

          {showUserForm && (
            <div className="form-section">
              <label>Select a Beneficiary</label>
              <select
                onChange={(e) => {
                  const selected = beneficiaryList.find((b) => b.name === e.target.value);
                  if (selected) {
                    setBeneficiary(selected);
                    setShowUserForm(false);
                  }
                }}
                defaultValue=""
              >
                <option value="" disabled>
                  Select beneficiary...
                </option>
                {beneficiaryList.map((b) => (
                  <option key={b.id} value={b.name}>
                    {b.name} - {b.age} yrs - {b.village}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      <div className="divider"></div>

      {/* Referral Details */}
      <div className="form-section">
        <h2 className="form-section-title">
          <span className="material-symbols-rounded form-section-icon">local_hospital</span>
          Referral Details
        </h2>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">
              Referred To<span className="form-required">*</span>
            </label>
            <select
              name="referredTo"
              className="form-select"
              value={formData.referredTo}
              onChange={handleInputChange}
            >
              <option value="">Select facility</option>
              <option>PHC Rampur</option>
              <option>CHC Sitapur</option>
              <option>District Hospital</option>
              <option>Private Clinic</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">
              Referral Date<span className="form-required">*</span>
            </label>
            <input
              type="date"
              name="referralDate"
              className="form-input"
              value={formData.referralDate}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">
            Reason for Referral<span className="form-required">*</span>
          </label>
          <textarea
            name="reasonForReferral"
            className="form-textarea"
            value={formData.reasonForReferral}
            onChange={handleInputChange}
          ></textarea>
        </div>

        <div className="form-group">
          <label className="form-label">
            Urgency Level<span className="form-required">*</span>
          </label>
          <div className="urgency-options">
            {['Routine', 'Urgent', 'Emergency'].map((label, index) => (
              <div
                key={index}
                className={`urgency-option${formData.urgencyLevel === label ? ' selected' : ''}`}
                onClick={() => setFormData({ ...formData, urgencyLevel: label })}
              >
                <span className="material-symbols-rounded urgency-icon">
                  {label === 'Urgent' ? 'priority_high' : 'calendar_today'}
                </span>
                <div className="urgency-label">{label}</div>
                <div className="urgency-description">
                  {['Within 7 days', 'Within 3 days', 'Within 24 hours'][index]}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="divider"></div>

      {/* Transport Section */}
      <div className="form-section">
        <h2 className="form-section-title">
          <span className="material-symbols-rounded form-section-icon">directions_bus</span>
          Transport & Logistics
        </h2>

        <div className="form-group">
          <label className="form-label">Transport Needed?</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="transportNeeded"
                value="no"
                checked={formData.transportNeeded === 'no'}
                onChange={handleInputChange}
              />
              <span className="radio-label">No</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="transportNeeded"
                value="yes"
                checked={formData.transportNeeded === 'yes'}
                onChange={handleInputChange}
              />
              <span className="radio-label">Yes</span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Transport Type</label>
          <div className="transport-options">
            {['Family Vehicle', 'Ambulance / Taxi', 'Public Transport'].map((label, idx) => (
              <div
                key={idx}
                className={`transport-option${formData.transportType === label ? ' selected' : ''}`}
                onClick={() => setFormData({ ...formData, transportType: label })}
              >
                <span className="material-symbols-rounded transport-icon">
                  {label === 'Family Vehicle'
                    ? 'family_restroom'
                    : label === 'Ambulance / Taxi'
                    ? 'local_taxi'
                    : 'directions_bus'}
                </span>
                <div className="transport-label">{label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Escort Needed?</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="escortNeeded"
                  value="no"
                  className="radio-input"
                  checked={formData.escortNeeded === 'no'}
                  onChange={handleInputChange}
                />
                <span className="radio-label">No</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="escortNeeded"
                  value="yes"
                  className="radio-input"
                  checked={formData.escortNeeded === 'yes'}
                  onChange={handleInputChange}
                />
                <span className="radio-label">Yes</span>
              </label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Escort Person</label>
          <select
            className="form-select"
            name="escortPerson"
            value={formData.escortPerson}
            onChange={handleInputChange}
          >
            <option value="">Select person</option>
            <option>Family Member</option>
            <option>ASHA Worker</option>
            <option>ANM</option>
            <option>Other Health Worker</option>
          </select>
        </div>
      </div>

      <div className="divider"></div>

      {/* Additional Information */}
      <div className="form-section">
        <h2 className="form-section-title">
          <span className="material-symbols-rounded form-section-icon">description</span>
          Additional Information
        </h2>

        <div className="form-group">
          <label className="form-label">Current Symptoms/Vital Signs</label>
          <textarea
            className="form-textarea"
            name="symptoms"
            value={formData.symptoms}
            onChange={handleInputChange}
            placeholder="Describe current symptoms and vital signs"
          />
          <div className="helper-text">Include any relevant medical history or current medications</div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Referral Slip Given?</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="slipGiven"
                  value="no"
                  className="radio-input"
                  checked={formData.slipGiven === 'no'}
                  onChange={handleInputChange}
                />
                <span className="radio-label">No</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="slipGiven"
                  value="yes"
                  className="radio-input"
                  checked={formData.slipGiven === 'yes'}
                  onChange={handleInputChange}
                />
                <span className="radio-label">Yes</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Previous Hospital Visit</label>
            <input
              type="date"
              name="hospitalVisit"
              className="form-input"
              value={formData.hospitalVisit}
              onChange={handleInputChange}
            />
            <div className="helper-text">If applicable</div>
          </div>
        </div>
      </div>

      <div className="divider"></div>

      {/* Follow-up Plan */}
      <div className="form-section">
        <h2 className="form-section-title">
          <span className="material-symbols-rounded form-section-icon">event_repeat</span>
          Follow-up Plan
        </h2>

        <div className="form-group">
          <label className="checkbox-option">
            <input
              type="checkbox"
              name="followUpScheduled"
              className="checkbox-input"
              checked={formData.followUpScheduled}
              onChange={handleInputChange}
            />
            <span className="checkbox-label">Schedule follow-up after referral</span>
          </label>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Expected Follow-up Date</label>
            <input
              type="date"
              name="followUpDate"
              className="form-input"
              value={formData.followUpDate}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Follow-up Type</label>
            <select
              className="form-select"
              name="followUpType"
              value={formData.followUpType}
              onChange={handleInputChange}
            >
              <option value="">Select type</option>
              <option>Home Visit</option>
              <option>Phone Call</option>
              <option>Ask to Visit ASHA</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Follow-up Notes</label>
          <textarea
            className="form-textarea"
            name="followUpNotes"
            value={formData.followUpNotes}
            onChange={handleInputChange}
            placeholder="Any notes for follow-up"
          />
        </div>
      </div>

      {/* Submit Button */}
      <div className="actions">
        <button className="btn btn-secondary" type="button" onClick={() => navigate('/referrals')}>
          <span className="material-symbols-rounded btn-icon">close</span>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary" onClick={handleSave}>
          <span className="material-symbols-rounded btn-icon">save</span>
          Save Referral
        </button>
      </div>
      </>
  );
};

export default VhndCreate;  